<script setup lang="ts">
import SectionHeadline from '@/shared/components/SectionHeadline.vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
</script>
<template>
  <SectionHeadline :headline="t('companyHeading')" />
</template>
